import React, { useEffect } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import { SearchSelectBox } from 'jbc-front/components/SearchForm';
import { arrowRenderer } from 'jbc-front/components/Form';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { isYearFormat } from 'src/utils/CustomValidators';
import styles from 'src/components/PaymentYearCalendarWithOfficeSelectBoxes.scss';
import { CustomYearPicker } from '../features/Employees/components/CustomYearPicker';

const PaymentYearCalendarWithOfficeSelectBoxes = props => {
  const { groupedPaymentYears, offices, currentYear, dispatch, formName } = props;

  useEffect(
    () => {
      if (_.isEmpty(groupedPaymentYears)) {
        return;
      }
      if (currentYear) {
        return;
      }
      dispatch(change(formName, 'groupedPaymentYears', groupedPaymentYears[0].value));
    },
    [groupedPaymentYears]
  );

  useEffect(
    () => {
      if (_.isEmpty(offices)) {
        return;
      }
      dispatch(change(formName, 'offices', offices[0].value));
    },
    [offices]
  );

  const isAvailableDate = currentDate => {
    const datePickerYear = new Date(currentDate).getFullYear();
    const availableYears = _.map(groupedPaymentYears, 'value');
    return availableYears.includes(datePickerYear.toString());
  };

  const onYearPickerChange = e => {
    const selectYear = moment(e).year();
    dispatch(change(formName, 'groupedPaymentYears', selectYear.toString()));
  };

  return (
    <div className={styles.container}>
      <div className={styles.yearPickerWrapper}>
        <CustomYearPicker
          label={null}
          name="groupedPaymentYears"
          validate={isYearFormat}
          isValidDate={currentDate => isAvailableDate(currentDate)}
          value={currentYear || ''}
          onChange={onYearPickerChange}
        />
      </div>
      <div className={styles.payrollRuleGroupsWrapper}>
        <Field name="offices" component={SearchSelectBox} options={offices} arrowRenderer={arrowRenderer} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  groupedPaymentYears: getSelectOptions(state, 'groupedPaymentYears'),
  offices: getSelectOptions(state, 'clientBranches')
});

export default connect(mapStateToProps)(PaymentYearCalendarWithOfficeSelectBoxes);
